import type { FC, PropsWithChildren } from 'react';
import { MdxProvider, SiteProvider } from '@anywayseo/tools';

import FooterExtra from './footer-extra';
import useSite from './use-site';

type SiteWrapperProps = PropsWithChildren;

const SiteWrapper: FC<SiteWrapperProps> = ({ children }) => {
  const { logo, metadata, navigation, localization } = useSite();

  return (
    <SiteProvider
      logo={logo}
      metadata={metadata}
      navigation={navigation}
      localization={localization}
      config={{
        footer: {
          extra: <FooterExtra />,
          navigationColumns: { base: 1, sm: 2, md: 3 },
        },
      }}
    >
      <MdxProvider>{children}</MdxProvider>
    </SiteProvider>
  );
};

export default SiteWrapper;
